export const imageCodes = {
    bgImage: {
        code: "${merchantId}_tmpl_img_25",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fframe4.png?alt=media&token=4e1208a6-618d-477a-822e-9a808d207b1b",
    },
    category1: {
        code: "${merchant}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FcleanCate.webp?alt=media&token=62fdb52e-1acd-455a-a1ad-40c8f02557b1"
    },

    category2: {
        code: "${merchant}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FmoistCate.webp?alt=media&token=5ce763eb-ca2d-48ca-9831-215588b815d9"
    },

    category3: {
        code: "${merchant}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FbabeCate.webp?alt=media&token=b3d762e2-9293-4133-92a5-05f06d1c4fbd"
    },

    category4: {
        code: "${merchant}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FsunCate.webp?alt=media&token=a00abeaf-709f-4b27-966f-b4246dcd8368"
    },

    category5: {
        code: "${merchant}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FdayCate.webp?alt=media&token=17fe7d6f-ad7f-43a8-9693-8c75bdd4f951"
    },

    product1: {
        code: "${merchant}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpd2.png?alt=media&token=c71f2329-28a5-46ef-8028-4033e507c5bd"
    },

    product2: {
        code: "${merchant}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpd3.png?alt=media&token=3521e4a1-9685-40ee-bc9c-306077921bde"
    },

    product3: {
        code: "${merchant}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpd4-4.png?alt=media&token=a12c2743-a40d-4656-b404-edbad2832440"
    },

    product4: {
        code: "${merchant}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpd1.png?alt=media&token=fe593583-a4f5-422b-b69a-471b499fb9e2"
    },

    product5: {
        code: "${merchant}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FCetaphil%20Pro%20Acne%20Prone%20Oil%20Control%20Foam%20Face%20Wash%20236mL-1.webp?alt=media&token=7232a85a-66ad-4a4c-a441-fe7919accda1"
    },

    product6: {
        code: "${merchant}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpd5.png?alt=media&token=d8223833-ac67-460b-afe4-895d475305ed"
    },

    doctor: {
        code: "${merchant}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fdoctor.webp?alt=media&token=51ca2acc-5844-4f13-ba70-b173dd887aae"
    },

    heropd1: {
        code: "${merchant}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fc4.png?alt=media&token=a20c0646-dbc3-40d4-990f-db6c00c02b5d"
    },

    heropd2: {
        code: "${merchant}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fc%201.png?alt=media&token=a01541ac-3a04-46b0-9281-dbefd50a4554"
    },

    heropd3: {
        code: "${merchant}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fc3.png?alt=media&token=d3ef6610-f10f-49ba-aa32-38d3d3ec8de7"
    },

    heropd4: {
        code: "${merchant}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpp3.png?alt=media&token=d8ac2c60-cc75-4733-8e29-618b15c1cbb7"
    },

    heropd5: {
        code: "${merchant}_tmpl_img_21",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhpd1.png?alt=media&token=cf20b016-a78b-44cc-a9fa-335fbbac15ea"
    },

    serie1: {
        code: "${merchant}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fset2.png?alt=media&token=bbe91e31-60f6-4d31-a5c7-a5c2fa22089c"
    },

    serie2: {
        code: "${merchant}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fset3.png?alt=media&token=0817d519-7bc0-4b62-94a6-bd9abbc56e8a"
    },

    serie3: {
        code: "${merchant}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FFB_IMG_1657032920395.jpg?alt=media&token=952614ac-541a-406b-a184-01918d1bbdff"
    },

    serie4: {
        code: "${merchant}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fset1.png?alt=media&token=6990b806-a5f1-4881-bf1f-5eabc293a79b"
    },

    home_Slider: {
        code: "${merchant}_tmpl_img_22",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fframe4.png?alt=media&token=ae8b4844-62a6-45cd-9c5b-f67990c69a95"
    },

    home_Slider_Mobile: {
        code: "${merchant}_tmpl_img_23",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fframe3.png?alt=media&token=95629f0a-afbf-4220-b9d8-a4e213387710"
    },

    banner: {
        code: "${merchant}_tmpl_img_27",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbanners%201.png?alt=media&token=51dc0f9b-3f52-4c95-b759-597c65237f91"
    },

}

export const titleCodes = {
    categoryTitle: {
        code: "${merchant}_tmpl_title_1",
        title: "Discover more from Cetaphil"
    },

    doctorBrand: {
        code: "${merchant}_tmpl_title_2",
        title: "#1 DOCTOR RECOMMENDED SENSITIVE SKINCARE"
    },

    featureTitle: {
        code: "${merchant}_tmpl_title_3",
        title: "Featured Products"
    },

    seriesTitle: {
        code: "${merchant}_tmpl_title_4",
        title: "Cetaphil Value Set"
    },

    getWeb: {
        code: "${merchant}_tmpl_title_5",
        title: "Get it on website"
    },
}

export const textCodes = {

    divider: {
        code: "${merchant}_tmpl_text_20",
        text: "── x ──"
    },

    categoryText: {
        code: "${merchant}_tmpl_text_1",
        text: "Get the best care for your sensitive skin across all our product ranges."
    },

    cat1: {
        code: "${merchant}_tmpl_text_2",
        text: "Cleanser ──"
    },

    cat2: {
        code: "${merchant}_tmpl_text_3",
        text: "Moisturizer ──"
    },

    cat3: {
        code: "${merchant}_tmpl_text_4",
        text: "Cetaphil Baby ──"
    },

    cat4: {
        code: "${merchant}_tmpl_text_5",
        text: "Sun Protection ──"
    },


    cat5: {
        code: "${merchant}_tmpl_text_6",
        text: "Bright Healthy Radiance ──"
    },

    doctor1: {
        code: "${merchant}_tmpl_text_7",
        text: "Partnering closely with dermatologists and healthcare professionals, we have carried out more than 550 clinical studies on over 32,000 patients to ensure the efficacy and safety of our products for sensitive skin."
    },

    doctor2: {
        code: "${merchant}_tmpl_text_8",
        text: "Years of experience in caring for skin has earned Cetaphil the trust of both dermatologists and patients."
    },

    pd1: {
        code: "${merchant}_tmpl_text_9",
        text: "Cetaphil Baby Daily Lotion - Shea Butter"
    },

    pd2: {
        code: "${merchant}_tmpl_text_10",
        text: "Brightening Day Cream SPF 15"
    },

    pd3: {
        code: "${merchant}_tmpl_text_11",
        text: "Gentle skin cleanser 125ml New"
    },

    pd4: {
        code: "${merchant}_tmpl_text_12",
        text: "Pro AD Derma Wash"
    },

    pd5: {
        code: "${merchant}_tmpl_text_13",
        text: "Gentle skin cleanser 125ml NEW"
    },

    pd6: {
        code: "${merchant}_tmpl_text_27",
        text: "Daily Exfoliating Cleanser 178ml"
    },

    shopNow: {
        code: "${merchant}_tmpl_text_19",
        text: "shop now"
    },

    series1: {
        code: "${merchant}_tmpl_text_29",
        text: "Gentle Skin Cleanser Starter Set"
    },

    series2: {
        code: "${merchant}_tmpl_text_31",
        text: "Gentle 29ml + Moisture 15g set"
    },

    series3: {
        code: "${merchant}_tmpl_text_28",
        text: "UVA + Gentle Cleanser + Moisturizing Cream Set"
    },

    series4: {
        code: "${merchant}_tmpl_text_30",
        text: "Gentle 59ml + Moisture 59ml set"
    },

}

export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_1",
        video: "https://www.youtube.com/embed/Isd1j-F-oSM"
    }
}